// Toggles the display and enabled/disabled state of elements based on the value of a trigger element.
// The trigger element can be a form input or any element with a data-value attribute.
// Toggle elements should have a data-toggle-value attribute that matches the value of the trigger element to be shown.
// Use data-toggle-outcome="hide", "disable", or "hide-disable" to control whether the element is hidden, disabled, or both (default: "hide-disable").
// Example: triggers on a select's options, and shows/hides or enables/disables div elements based on the selected option.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "toggle"]

  connect() {
    this.update()
  }

  update() {
    let value = this.triggerTarget.value || this.triggerTarget.dataset.value
    this.toggleTargets.forEach(target => {
      const outcome = target.dataset.toggleOutcome || "hide-disable"
      const shouldShow = target.dataset.toggleValue === value

      if (outcome === "hide") {
        target.style.display = shouldShow ? "" : "none"
      } else if (outcome === "disable") {
        target.querySelectorAll("input, select, textarea").forEach(input => {
          input.disabled = !shouldShow
        })
      } else if (outcome === "hide-disable") {
        target.style.display = shouldShow ? "" : "none"
        target.querySelectorAll("input, select, textarea").forEach(input => {
          input.disabled = !shouldShow
        })
      }
    })
  }
}
